import React, { Component } from 'react'
import { domains } from '../../lib/config'

export default class BpuTrainingResources extends Component {
  render() {
    const cdnBase = `${domains.CDN_DOMAIN}/assets/pdfs/bpu/docs`

    return (
      <div>
        <h4>Bullying Prevention Training Resources</h4>
        <h6>Module 1</h6>
        <div className="rule-header" />
        <h5>Resources for Principals and Program Coordinators</h5>
        <p>
          <a
            href={`${cdnBase}/Module1/Staff_Scavenger_Hunt_BPU.pdf`}
            target="_blank"
          >
            Staff Activity: Policies and Procedures Scavenger Hunt
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Sample_Email_Responses_BPU.pdf`}
            target="_blank"
          >
            Sample Email Responses to Parent Bullying Concerns
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Enviro_Scan_Overview_BPU.pdf`}
            target="_blank"
          >
            Environmental Scan: Overview
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Enviro_Scan_Phys_Feature_Wrksheet_BPU.pdf`}
            target="_blank"
          >
            Environmental Scan: Physical Features Worksheet
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Enviro_Scan_Student_Bhvr_Wrksheet_BPU.pdf`}
            target="_blank"
          >
            Environmental Scan: Student Behaviors Worksheet
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Environ_Scan_Supervsn_Sched_Wrksheet_BPU.pdf`}
            target="_blank"
          >
            Environmental Scan: Supervision and Scheduling Worksheet
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Staff_Snapshot_Survey_BPU.pdf`}
            target="_blank"
          >
            Staff Snapshot Survey
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Student_Snapshot_Survey_BPU.pdf`}
            target="_blank"
          >
            Student Snapshot Survey
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Sample_Anti-Bully_Policies_BPU.pdf`}
            target="_blank"
          >
            Sample Anti-Bullying Policies and Procedures
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/Sample_Hierarchy_Cnsqncs_BPU.pdf`}
            target="_blank"
          >
            Sample Hierarchy of Consequences
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <br />
        <h6>Module 2</h6>
        <div className="rule-header" />
        <h5>Resources for All Staff</h5>
        <p>
          <a
            href={`${cdnBase}/Module2/Sample_Bullying_Report_Form_BPU.pdf`}
            target="_blank"
          >
            Sample Bullying Report Form
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module2/Student_Safety_Plan_BPU.pdf`}
            target="_blank"
          >
            Student Safety Plan
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module2/Student_Behavior-Change_Plan_BPU.pdf`}
            target="_blank"
          >
            Student Behavior-Change Plan
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <br />
        <h6>Module 3</h6>
        <div className="rule-header" />
        <h5>Resources for Staff Teaching the Lessons</h5>
        <p>
          <a
            href={`${cdnBase}/Module3/Guidelines_Making_Class_Rules_BPU.pdf`}
            target="_blank"
          >
            Guidelines for Making Class Rules
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/How_to_Create_Refuse_Sgnl_BPU.pdf`}
            target="_blank"
          >
            How to Create a Refuse Signal
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a href={`${cdnBase}/Module3/Buddy_Plan_BPU.pdf`} target="_blank">
            Buddy Plan
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/Class_Meeting_Template_BPU.pdf`}
            target="_blank"
          >
            Class Meeting Introduction and Template
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/Friendship_Survey_BPU.pdf`}
            target="_blank"
          >
            Friendship Survey
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/Indiv_Student_Time_Trckng_BPU.pdf`}
            target="_blank"
          >
            Individual Student Time Tracking Chart
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <br />
        <h5>Summative Knowledge Assessment, Teacher</h5>
        <p>
          <a
            href={`${cdnBase}/Module3/K_Summtive_Knldge_Assmnt_Tchr_BPU.pdf`}
            target="_blank"
          >
            Kindergarten
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G1_Summative_Knldge_Assmnt_Tchr_BPU.pdf`}
            target="_blank"
          >
            Grade 1
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G2_Summtive_Knldge_Assmnt_Tchr_BPU.pdf`}
            target="_blank"
          >
            Grade 2
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G3_Summtive_Knldge_Assmnt_Tchr_BPU.pdf`}
            target="_blank"
          >
            Grade 3
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G4_Teach_Summative_Know_Assess_BPU.pdf`}
            target="_blank"
          >
            Grade 4
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G5_Teach_Summative_Assessments_BPU.pdf`}
            target="_blank"
          >
            Grade 5
          </a>
        </p>
        <br />
        <h5>Summative Knowledge Assessment, Student</h5>
        <p>
          <a
            href={`${cdnBase}/Module3/K_Summtive_Knldge_Assmnt_Sdnt_BPU.pdf`}
            target="_blank"
          >
            Kindergarten
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G1_Summative_Knldge_Assmnt_Stdnt_BPU.pdf`}
            target="_blank"
          >
            Grade 1
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G2_Summtive_Knldge_Assmnt_Stdnt_BPU.pdf`}
            target="_blank"
          >
            Grade 2
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G3_Summtive_Knldge_Assmnt_Stdnt_BPU.pdf`}
            target="_blank"
          >
            Grade 3
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G4_Student_Summative_Know_Assess_BPU.pdf`}
            target="_blank"
          >
            Grade 4
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G5_Student_Summative_Assessments_BPU.pdf`}
            target="_blank"
          >
            Grade 5
          </a>
        </p>
        <br />
        <h5>Classroom Climate Survey, Teacher</h5>
        <p>
          <a
            href={`${cdnBase}/Module3/K_G1_Classrm_Climate_Survey_Tchr_BPU.pdf`}
            target="_blank"
          >
            Kindergarten
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/K_G1_Classrm_Climate_Survey_Tchr_BPU.pdf`}
            target="_blank"
          >
            Grade 1
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G2_G3_Classrm_Climate_Survey_Tchr_BPU.pdf`}
            target="_blank"
          >
            Grade 2
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G2_G3_Classrm_Climate_Survey_Tchr_BPU.pdf`}
            target="_blank"
          >
            Grade 3
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G4-5_Teach_Climate_Survey_BPU.pdf`}
            target="_blank"
          >
            Grade 4
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G4-5_Teach_Climate_Survey_BPU.pdf`}
            target="_blank"
          >
            Grade 5
          </a>
        </p>
        <br />
        <h5>Classroom Climate Survey, Student</h5>
        <p>
          <a
            href={`${cdnBase}/Module3/K_G1_Classrm_Climate_Survey_Stdnt_BPU.pdf`}
            target="_blank"
          >
            Kindergarten
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/K_G1_Classrm_Climate_Survey_Stdnt_BPU.pdf`}
            target="_blank"
          >
            Grade 1
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G2_G3_Classrm_Climate_Survey_Stdnt_BPU.pdf`}
            target="_blank"
          >
            Grade 2
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G2_G3_Classrm_Climate_Survey_Stdnt_BPU.pdf`}
            target="_blank"
          >
            Grade 3
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G4-5_Student_Climate_Survey_BPU.pdf`}
            target="_blank"
          >
            Grade 4
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/G4-5_Student_Climate_Survey_BPU.pdf`}
            target="_blank"
          >
            Grade 5
          </a>
        </p>
        <br />
        <br />
        <style jsx>
          {`
            h4 {
              font-size: 2rem;
              color: #f5961f;
              padding: 20px 0 5px 0;
            }

            h5 {
              font-weight: 100;
            }

            .rule-header {
              margin-bottom: 15px;
              width: 100%;
              height: 1px;
              overflow: hidden;
              margin-top: 0px;
              background-color: #ddd;
            }
          `}
        </style>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/static-training/BpuTrainingResource.js